import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./infrastructure/Firebase/context/AuthContext";
import { GeoProvider } from "./infrastructure/context/GeoContext";
import SessionExpirationBoundary from "./app/components/session/SessionExpirationBoundary";

// Configuración del script de Google Analytics
const GA_MEASUREMENT_ID = process.env.REACT_APP_GOOGLE_ANALITYCS; // Reemplaza con tu ID de medición

const addGoogleAnalytics = () => {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", GA_MEASUREMENT_ID);
  };
};

addGoogleAnalytics();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SessionExpirationBoundary>
      <AuthProvider>
        <GeoProvider>
          <App />
        </GeoProvider>
      </AuthProvider>
    </SessionExpirationBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
